module.exports = __webpack_public_path__ + "static/media/sell_resend_invoice_3.47b0fd2f.jpg";